import { Link, useLocation } from "react-router-dom";
import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <Header />
      <main className="flex flex-1 items-center justify-center px-4 py-20">
        <div className="mx-auto max-w-xl text-center">
          <p className="font-serif-cn text-[96px] font-black leading-none text-background-300 md:text-[140px]">
            404
          </p>
          <h1 className="-mt-4 font-serif-cn text-2xl font-bold text-foreground-950 md:text-3xl">
            这个页面找不到了
          </h1>
          <p className="mt-3 text-sm text-foreground-600">
            你访问的地址可能已经调整或下线：
            <span className="mx-1 rounded bg-background-100 px-2 py-0.5 font-mono text-xs text-foreground-700">
              {location.pathname}
            </span>
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Link
              to="/"
              className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 text-sm text-background-50 transition hover:bg-primary-600"
            >
              回到首页
            </Link>
            <Link
              to="/category/kuaixun"
              className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 px-6 py-2.5 text-sm text-foreground-800 transition hover:border-primary-400 hover:text-primary-600"
            >
              看看即时快讯
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}